import { RootState } from '@/types/state';

export const selectIsTimePickerShown = (state: RootState) => state.process.isTimePickerShown;
export const selectExpandedRowKeys = (state: RootState) => state.process.expandedRowKeys;
export const selectHomepage = (state: RootState) => state.process.homepage;
export const selectNavigated = (state: RootState) => state.process.navigated;
export const selectFavorites = (state: RootState) => state.process.favorites;
export const selectIsBookingLoad = (state: RootState) => state.process?.isBookingLoad;
export const selectActiveBookings = (state: RootState) => state.process.activeBookings;
